module.exports = __webpack_public_path__ + "media/images/kalaahaus-32x32-b8d15fce7dfb8ca0da68baaeecc9a62e.png";